export default {
      id: "power-of-compouding-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#power-of-compouding",
      toString: function () {
        return this.url;
      }
    }